"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadObject = void 0;
const is_defined_1 = require("../../validation/is-defined/is-defined");
/**
 * Loads an object from the web storage
 * @alpha
 *
 * @typeParam TObject - the type of the object to be loaded
 * @typeParam TDefault - the type of the object to be loaded, this is used to infer the type of the `defaultValue` so we make sure to always return a value
 *
 * @param key - The key identifying the object in the storage
 * @param defaultValue - A default value to set in case the object does not exist in the storage
 *
 * @returns The object loaded from the storage if found or `defaultValue` if was provided, else null
 *
 * @example
 * ```ts
 * const unknownObject = loadObject('unknown?'); // unknownObject is unknown
 * const alwaysObject = loadObject('noNullAssertionNeeded', {a:'b'}); // alwaysObject is expected to always have a value in the form of defaultValue
 * const possibleNullObject = loadObject<{a:string}>('nullAssertionNeeded'); // possibleNullObject is expected to have a value in the form of defaultValue or null
 * ```
 */
function loadObject(key, defaultValue) {
    var _a;
    const result = JSON.parse((_a = localStorage.getItem(key)) !== null && _a !== void 0 ? _a : 'null');
    if ((0, is_defined_1.isDefined)(result))
        return result;
    if ((0, is_defined_1.isDefined)(defaultValue))
        return defaultValue;
    return null;
}
exports.loadObject = loadObject;
//# sourceMappingURL=load-object.js.map